import { InputAction } from '../input/InputAction';

/** Keyboard bindings use KeyboardEvent.code (layout independent: KeyW = W on QWERTZ too). */
export type KeyBindings = Readonly<Record<InputAction, readonly string[]>>;

export interface InputConfig {
  readonly keyBindings: KeyBindings;
  readonly swipe: {
    /** Minimum swipe distance as a fraction of the shorter screen edge. */
    readonly minDistanceFraction: number;
    /** Absolute lower bound in CSS pixels (very small screens). */
    readonly minDistancePx: number;
    /** A touch that takes longer than this is not a swipe (ms). */
    readonly maxDurationMs: number;
  };
}

export const INPUT_CONFIG: InputConfig = {
  keyBindings: {
    [InputAction.MoveLeft]: ['KeyA', 'ArrowLeft'],
    [InputAction.MoveRight]: ['KeyD', 'ArrowRight'],
    [InputAction.Jump]: ['KeyW', 'ArrowUp'],
    [InputAction.Slide]: ['KeyS', 'ArrowDown'],
    [InputAction.SlideRelease]: [], // produced by releasing a Slide key (KeyboardInputSource)
    [InputAction.Pause]: ['Escape', 'KeyP'],
    [InputAction.Confirm]: ['Space', 'Enter'],
    [InputAction.Restart]: ['KeyR'],
    [InputAction.ToggleDebug]: ['F3', 'Backquote'],
  },
  swipe: {
    minDistanceFraction: 0.06,
    minDistancePx: 24,
    maxDurationMs: 450,
  },
};
